import wixWindow from 'wix-window';
import wixData from 'wix-data';

$w.onReady(async function () {
    let language = await wixWindow.multilingual.currentLanguage; // "en", "he";
    console.log("languge: " + language);

    $w("#dynamicDataset").onReady(() => {
        let projectName, shortDescription;
        let description, readMore;
        let item = $w("#dynamicDataset").getCurrentItem();
        if (language === 'en') {
            projectName = item.title;
            shortDescription = item.shortDescription;
            description = item.longDescription;
            readMore = item.readMoreText;
        } else if (language === 'he') {
            projectName = item.projectNameHeb;
            shortDescription = item.shortDescriptionHeb;
            description = item.longDescHeb;
        }
        $w("#projectName").text = projectName;
        $w("#shortDescription").text = shortDescription;
        $w("#description").value = description;
        if (shortDescription) {
            $w("#shortDescription").show();
        }
        if (description) {
            $w("#description").show();
        }
        if ($w("#gallery").items.length > 0) {
            $w("#gallery").expand();
        }
    })
});